export const smallMobileSize = "screen and (max-width: 550px)";
export const mobileSize = "screen and (max-width: 768px)";
export const laptopSize = "screen and (max-width: 992px)";
export const desktopSize = "screen and (max-width: 1280px)";
export const largeDesktopSize = "screen and (max-width: 1440px)";
export const veryLargeDesktopSize = "screen and (max-width: 1700px)";
